module.exports = __webpack_public_path__ + "static/media/RobotoMono-LightItalic.a70d962a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/RobotoMono-LightItalic.ttf
// module id = 112
// module chunks = 0